import Link from 'next/link';
import { Layout, Skeleton } from 'antd';
import Image from 'next/image';
import cei from './CatalogExplorerItem.module.scss';
import { ECatalogCategoryViewType } from 'tkmp-lib/src/enums';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

// @ts-ignore
const CatalogExplorerItem = ({ element, type = ECatalogCategoryViewType.Card }: any) => {
    const LOCALIZATION = useLocalization();
    return (
        <Link
            style={{ height: 'fit-content' }}
            href={`/catalog/${element?.fpathSlug?.slice(1).join('/')}${
                element?.count > 0 && element?.inner.length === 0 ? '' : ''
            }${element?.isBrand ? `/brand/${element?.brand_name}` : ''}`}
        >
            <Layout
                className={`${cei.gridItem} ${type === ECatalogCategoryViewType.Row && cei.rowItem}`}
            >
                <Layout className={cei.gridItemPictureBlock}>
                    {element.logo === undefined ? (
                        <Skeleton.Image
                            active
                            style={{ height: '100%' }}
                            className={cei.gridItemPicture}
                        ></Skeleton.Image>
                    ) : (
                        <Image
                            width={0}
                            height={0}
                            sizes={'100%'}
                            alt={''}
                            src={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${element.logo}`}
                            className={cei.gridItemPicture}
                        />
                    )}
                </Layout>
                <Layout className={cei.gridItemDescription}>
                    <span className={cei.gridItemName}>{element?.name}</span>
                    <span className={cei.gridItemCount}>
                        {element?.count} {LOCALIZATION.pages.catalog.header.products}
                    </span>
                </Layout>
            </Layout>
        </Link>
    );
};

export default CatalogExplorerItem;
